module.exports = __webpack_public_path__ + "img/link.fa89befc.svg";